export class Sheet {
  sheetHash = ''
  personalData: { [key: string]: string } = {}
  answers: (string | null)[] = []
  questions: (string | null)[] = []
  sheetNote = ''
  confirmFlg = null
  confirmName = ''
  confirmDt = ''
  constructor(initData?: Partial<Sheet>) {
    Object.assign(this, initData)
  }
}
